// jQueryFree
export default function () {
	document.querySelector('.mobileSearchButton')?.addEventListener('click', function (e) {
		// klik na tlačíkto Upravit filtry na mobilu
		let filterCont = e.currentTarget.closest('div.common-search')?.querySelector('.mobileSearchButtonCont');

		if (filterCont instanceof Element) {
			filterCont.classList.toggle('openCont');
			filterCont.classList.toggle('setOverflow');
		}

		let topSearchCont = e.currentTarget
			.closest('div.top-search-cont')
			?.querySelector('.filter-control-button-cont');
		if (topSearchCont instanceof Element) {
			topSearchCont.classList.toggle('showFilterNav');
		}

		document.querySelector('.filter-control-button.show-filters')?.click();
	});

	document.querySelector('.close-filters-button')?.addEventListener('click', function (e) {
		document.querySelector('.mobileSearchButtonCont').classList.remove('openCont');
		document.querySelector('.mobileSearchButtonCont').classList.remove('setOverflow');
	});

	document.querySelectorAll('.filter-show-button').forEach(function (btn) {
		btn.addEventListener('click', function (e) {
			let isRewardSearch = document.getElementsByClassName('search-reward').length > 0;
			let clickedButton = e.currentTarget;

			let isShow = parseInt(clickedButton.dataset.show);
			if (isShow === 0) {
				if (window.innerWidth > 1000) {
					if (document.querySelector('.preferences-search') instanceof Element) {
						document.querySelectorAll('.filters-item:nth-of-type(1n+3)').forEach(function (el) {
							el.style.display = 'inline-block';
						});
					} else {
						document.querySelectorAll('.filters-item:nth-of-type(1n+4)').forEach(function (el) {
							el.style.display = 'inline-block';
						});
					}
				} else {
					if (document.querySelector('.preferences-search') instanceof Element) {
						document.querySelectorAll('.filters-item:nth-of-type(1n+3)').forEach(function (el) {
							el.style.display = 'block';
						});
					} else {
						document.querySelectorAll('.filters-item:nth-of-type(1n+4)').forEach(function (el) {
							el.style.display = 'block';
						});
					}
					clickedButton.style.display = 'none';
				}

				clickedButton.innerText = '- skrýt filtry';
				clickedButton.style.display = 'block';
				clickedButton.dataset.show = 1;
				clickedButton.closest('.filters-clear-wrapper-cont').classList.add('part-hide');
			} else {
				if (isRewardSearch) {
					document.querySelectorAll('.filters-item:nth-of-type(1n+3)').forEach(function (el) {
						el.style.display = 'none';
					});
				} else {
					document.querySelectorAll('.filters-item:nth-of-type(1n+4)').forEach(function (el) {
						el.style.display = 'none';
					});
				}

				clickedButton.innerText = '+ další filtry';
				clickedButton.dataset.show = 0;
			}

			e.preventDefault();
		});
	});

	window.addEventListener('resize', function (e) {
		let filterShowButton = document.querySelector('.filter-show-button');
		if (filterShowButton === null) {
			return;
		}

		let isShow = parseInt(filterShowButton.dataset.show);
		let width = window.innerWidth;

		if (width <= 1000 && isShow === 1) {
			document.querySelectorAll('.filters-item:nth-of-type(1n+5)').forEach(function (el) {
				el.style.display = 'block';
			});
			filterShowButton.style.display = 'none';
		} else if (width > 1000 && isShow === 1) {
			document.querySelectorAll('.filters-item:nth-of-type(1n+5)').forEach(function (el) {
				el.style.display = 'inline-block';
			});
			filterShowButton.style.display = 'block';
		}
	});

	//Úprava chování zobrazení filtrů pro sekci Práce pro cizince
	//Defaultní tlačítka z původní SearchControl jsou skrytá.
	function showFilters(event) {
		let topSearchButtonCont = document.querySelector('.filter-control-button-cont');
		let topSearchCont = topSearchButtonCont.closest('.top-search-cont');

		let filtersWrapper = topSearchCont.querySelector('.common-search .main .filters-wrapper');
		let { target: clickedElement } = event;
		let classList = clickedElement.classList;

		if (classList.contains('show-filters')) {
			document.querySelector('.mobileSearchButtonCont').classList.add('openCont');
			document.querySelector('.mobileSearchButtonCont').classList.add('setOverflow');
			filtersWrapper.classList.add('show-all-filters');
			filtersWrapper.classList.remove('hide-all-filters');
			topSearchButtonCont.classList.add('opened');
			topSearchCont.classList.add('opened');
			clickedElement.classList.add('hide-filters');
			clickedElement.classList.remove('show-filters');
			clickedElement.textContent = '- skrýt filtry';
		} else if (classList.contains('hide-filters')) {
			document.querySelector('.mobileSearchButtonCont').classList.remove('openCont');
			document.querySelector('.mobileSearchButtonCont').classList.remove('setOverflow');
			filtersWrapper.classList.add('hide-all-filters');
			filtersWrapper.classList.remove('show-all-filters');
			topSearchButtonCont.classList.remove('opened');
			topSearchCont.classList.remove('opened');
			clickedElement.classList.add('show-filters');
			clickedElement.classList.remove('hide-filters');
			clickedElement.textContent = '+ zobrazit filtry';
		}
	}

	let filterShowControlButton = document.querySelector('.filter-control-button.show-filters');
	if (filterShowControlButton) {
		filterShowControlButton.addEventListener('click', showFilters);
	}

	let filterClearControlButton = document.querySelector('.filter-control-button.hide-filters');
	if (filterClearControlButton) {
		filterClearControlButton.addEventListener('click', showFilters);
	}

	const topSearchCont = document.querySelector('.top-search-cont');
	if (topSearchCont) {
		const filtersWrapper = topSearchCont.querySelector('.filters-wrapper');
		if (filtersWrapper) {
			const filtersItems = filtersWrapper.querySelectorAll('.filters-item');
			const filtersButtons = topSearchCont.querySelector('.filter-control-button-cont');
			let isAnyOptionNotSelected = false;
			for (let i = 0; i < filtersItems.length; i++) {
				const filterItem = filtersItems[i];
				const select = filterItem.querySelector('select');
				if (select && !isAnyOptionNotSelected) {
					for (let i = 0; i < select.options.length; i++) {
						if (select.options[i].hasAttribute('selected')) {
							isAnyOptionNotSelected = true;
							break;
						}
					}
				}
				if (isAnyOptionNotSelected) {
					const openButton = filtersButtons.querySelector('.filter-control-button.show-filters');
					const clickEvent = new Event('click');
					openButton.dispatchEvent(clickEvent);
					break;
				}
			}
		}
	}
}
